import React, { useEffect } from "react";
import "./SnackBar.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { hideSnackbar } from "../../redux/confirmSnackbarSlice";

// This holds the dynamic callback ref outside the component
export const snackbarCallbackRef = {
  current: undefined as undefined | (() => void),
};

const SnackBar: React.FC = () => {
  const dispatch = useDispatch();
  const {
    isOpen,
    message,
    icon,
    buttonText,
    type = "success",
    autoCloseDuration,
    key,
  } = useSelector((state: RootState) => state.confirmSnackbar);

  useEffect(() => {
    if (isOpen && autoCloseDuration && autoCloseDuration > 0) {
      const timer = setTimeout(() => {
        dispatch(hideSnackbar());
      }, autoCloseDuration);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoCloseDuration, dispatch]);

  if (!isOpen) return null;

  const handleButtonClick = () => {
    if (snackbarCallbackRef.current) {
      snackbarCallbackRef.current();
    }
    dispatch(hideSnackbar());
  };

  return (
    <div key={key} className={`snackbar-container ${type} slide-in`}>
      {icon && <span className="snackbar-icon">{icon}</span>}
      <span className="snackbar-message">{message}</span>
      {buttonText && (
        <button className="snackbar-button" onClick={handleButtonClick}>
          {buttonText}
        </button>
      )}
      <span className="snackbar-close" onClick={() => dispatch(hideSnackbar())}>
        &times;
      </span>
    </div>
  );
};

export default SnackBar;
